import BaseLayout from '@/components/BaseLayout.vue'
import router from '@/router';
import api from '@/services/api';
import {mapActions, mapGetters} from 'vuex';
import Modal from '@/components/Partials/Modal.vue';

export default {
    name: 'promotionCompletion',

    components: {
        BaseLayout,
        Modal,
    },

    data() {
        return {
            numberOfContactedBuyers: '',
            promoterComment: '',
            showModal: false,
            potentialProducts: [],
            potentialProductsAtEnd: [],
        };
    },

    computed: {
        ...mapGetters({
            promotion: 'promotion/promotion',
        }),

        missingProductsAtStart() {
            return this.promotion.activePromotion.missing_products_at_start;
        },

        missingProductsAtStartArray() {
            return this.promotion.activePromotion ? this.promotion.activePromotion.missing_products_at_start_array : '';
        },

        missingProductsAtEnd() {
            return this.promotion.activePromotion.missing_products_at_end;
        },

        missingProductsAtEndArray() {
            return this.promotion.activePromotion ? this.promotion.activePromotion.missing_products_at_end_array : '';
        },

        /**
         * Get bnrs from missing products at start
         *
         * @return {*}
         */
        bnrStart() {
            return this.promotion.activePromotion.missing_products_at_start_array.map((productAtStart) => {
                return productAtStart.bnr;
            })
        },

        /**
         * Get bnrs from missing products at end
         *
         * @return {*}
         */
        bnrEnd() {
            return  this.promotion.activePromotion.missing_products_at_end_array.map((productAtEnd) => {
                return productAtEnd.bnr;
            })
        }
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),

        /**
         * Remove missing product from end
         * @param name
         */
        removeProductFromEnd(name) {
            this.promotion.activePromotion.missing_products_at_end_array = this.promotion.activePromotion.missing_products_at_end_array.filter((product) => {
                return product.name !== name;
            })
        },

        /**
         * Search new product from backend with bnr
         * @param type
         */
        searchNewProduct(type) {
            if (event.target.value == '') {
                return;
            }

            const params = new URLSearchParams();
            if (type === 'start') {
                params.append('selected_products', [...this.bnrStart].join());
            } else {
                params.append('selected_products', [...this.bnrEnd].join());
            }
            params.append('bnr', event.target.value);
            api.post('/api/products_search', params)
                .then((response) => {
                    if (type === 'start') {
                        this.potentialProducts = response.data.body.entries;
                    } else {
                        this.potentialProductsAtEnd = response.data.body.entries;
                    }
                })
                .catch((error) => {
                    //commit('SHOW_LOGIN_ERRORS', error.response.data);
                });
        },

        endPromotion() {
            // Get unique products at start
            let uniqMissingProductsAtStart = [...new Set(this.bnrStart)];
            // Get unique products at end
            let uniqMissingProductsAtEnd = [...new Set(this.bnrEnd)];

            const params = new URLSearchParams();

            // Check if there is dynamic questions from database and are filled by user
            this.promotion.activePromotion.additional_questions.map((question) => {
                params.append(`additional_questions[${question.id}]`, this.$refs[`question${question.id}`][0].value);
            });

            params.append('type', this.promotion.activePromotion.type.id);
            params.append('customer_count', this.numberOfContactedBuyers);
            params.append('comments', this.promoterComment);
            params.append('missing_products_at_start', uniqMissingProductsAtStart.join());
            params.append('missing_products_at_end', uniqMissingProductsAtEnd.join());
            api.post('/api/promotions_end', params)
                .then((response) => {
                    this.storePromotion();
                    router.replace('/home')
                })
                .catch((error) => {
                    //commit('SHOW_LOGIN_ERRORS', error.response.data);
                });
        },

        /**
         * Remove missing product from start
         * @param name
         */
        removeProductFromStart(name) {
            this.promotion.activePromotion.missing_products_at_start_array = this.promotion.activePromotion.missing_products_at_start_array.filter((product) => {
                return product.name !== name;
            })
        },

        /**
         * Add product to missing products
         *
         * @param bnr
         * @param name
         */
        addToMissingProductsAtEnd(bnr, name) {
            this.potentialProductsAtEnd = this.potentialProductsAtEnd.filter((product) => {
                return product.name !== name;
            })
            this.promotion.activePromotion.missing_products_at_end_array.push({bnr: bnr, name: name});
        },

        /**
         * Add product to missing products
         *
         * @param bnr
         * @param name
         */
        addToMissingProducts(bnr, name) {
            this.potentialProducts = this.potentialProducts.filter((product) => {
                return product.name !== name;
            })
            this.promotion.activePromotion.missing_products_at_start_array.push({bnr: bnr, name: name});
        },

        /**
         * Clear search input
         */
        clearSearchTermFromStart() {
            this.$refs['searchTerm'].value = '';
            this.potentialProducts = [];
        },

        /**
         * Clear search input
         */
        clearSearchTermFromEnd() {
            this.$refs['searchTermEnd'].value = '';
            this.potentialProductsAtEnd = [];
        },

        /**
         * Send user back
         */
        goBack() {
            router.replace('/promotion')
        },
    }
}